import { Injectable } from '@angular/core';
import { HttpDataService, IHttpDataCache } from '../../../../shared/http/http-data.service';

import { INamedObject } from '../../../../../type_definitions/datatypes';

type DocumentTypes = 'TICKET_DOCUMENTS' | 'OTHER_DOCUMENTS';
type AttachmentTypes = 'PO_CONFIR' | 'PO_CAVEAT';

export interface IDocumentMessage {
  type?: string;
  message?: string;
}

export interface IDocumentGroup {
  orderEntryDocumentClass:DocumentTypes;
  type:string;
  typeInfo?:string;
  typeCode?:string;
  comment:string;
  needsDocument:boolean;
  uploadAllowed:boolean;
  attachmentTypeId: AttachmentTypes | string;
  caveatDefinitionId:number;
  key:string;
  documents?:IOrderEntryDocument[];
  templates?: INamedObject[];
  id?: string;
  error?: IDocumentMessage;
}

export interface IOrderEntryDocument extends INamedObject {
  author:{
    id:number;
    firstname:string;
    lastname:string;
  };
  date:number;
  deleteAllowed:boolean;
  url?:string;
  uid?: number;
  catalogOutdated?:boolean;
  warning?: IDocumentMessage;
}

@Injectable()
export class OrderEntryDocumentsDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public isLoadingDone():Promise<boolean> {
    return this.cache.isLoadingDone();
  }

  public deleteDocument(document:IDocumentGroup):Promise<any> {
    const config = {
      method: 'DELETE',
      url: `rest/orderentry/documents/${document}`
    };

    return this.httpDataService.doHTTP(
      config,
      undefined,
      `Error deleting document: ${document}`
    );
  }

  public documents(webshopId:number, countryId:number, orderId:number, companyCountryId:number):Promise<IDocumentGroup[]> {
    return this.cache.doGET(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/documents`,
      {
        orderId: orderId,
        companyCountryId: companyCountryId
      },
      undefined,
      'Error loading documents'
    );
  }

  public clear():void {
    this.cache.clear();
  }
}